/** UI mock — password rules for staff accounts. */
export const STAFF_PASSWORD_MIN_LENGTH = 8;

export function validateStaffPassword(password, confirmPassword) {
  const errors = {};
  const pwd = String(password || '');
  const confirm = String(confirmPassword || '');

  if (!pwd) errors.password = 'Password is required';
  else if (pwd.length < STAFF_PASSWORD_MIN_LENGTH) {
    errors.password = `Min ${STAFF_PASSWORD_MIN_LENGTH} characters`;
  }

  if (!confirm) errors.confirmPassword = 'Confirm password is required';
  else if (pwd !== confirm) errors.confirmPassword = 'Passwords do not match';

  return errors;
}
